import { Card } from '@sho-bot/ui';
import { useId, type ReactNode } from 'react';

export function SettingsPage({ children }: { children: ReactNode }): ReactNode {
  return <div className="mx-auto grid w-full max-w-3xl gap-8 pb-8">{children}</div>;
}

export function SettingsSection({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}): ReactNode {
  const headingId = useId();

  return (
    <section aria-labelledby={headingId} className="grid gap-3">
      <h2 id={headingId} className="text-base font-medium">
        {title}
      </h2>
      <Card className="gap-0 py-0">{children}</Card>
    </section>
  );
}

export function SettingsRow({
  label,
  description,
  children,
}: {
  label: string;
  description?: ReactNode;
  children: ReactNode;
}): ReactNode {
  return (
    <div className="flex min-h-11 items-center gap-4 border-t border-border-secondary px-4 py-3 first:border-t-0">
      <div className="min-w-0 flex-1">
        <div className="text-sm font-medium">{label}</div>
        {description === undefined ? null : (
          <div className="mt-0.5 text-sm text-muted-foreground">{description}</div>
        )}
      </div>
      <div className="min-w-0 shrink-0 text-end text-sm">{children}</div>
    </div>
  );
}

export function SettingsValueRows({
  rows,
}: {
  rows: readonly (readonly [label: string, value: string])[];
}): ReactNode {
  return (
    <dl>
      {rows.map(([label, value]) => (
        <div
          key={label}
          className="flex min-h-11 items-center gap-4 border-t border-border-secondary px-4 py-3 first:border-t-0"
        >
          <dt className="min-w-0 flex-1 text-sm font-medium">{label}</dt>
          <dd className="max-w-[65%] break-words text-end text-sm text-muted-foreground">
            {value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
